import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Configuration } from '@app/models/config.model';
import { FeatureFlagsFacade, HttpMethod, IMaintenanceWindow, UiStateFacade } from '@ra-state';
import { ConfigService } from '@rockwell-automation-inc/service';
import { DateTime } from 'luxon';
import { EMPTY, Observable, mergeMap, of, tap } from 'rxjs';

@Injectable()
export class MaintenanceWindowInterceptor implements HttpInterceptor {
  private readonly featureFlagsFacade = inject(FeatureFlagsFacade);
  private readonly uiStateFacade = inject(UiStateFacade);
  private readonly configService = inject<ConfigService<Configuration>>(ConfigService);

  maintenanceWindow: IMaintenanceWindow;

  // this is one time subscription, we cann't call inside intrecept, as intercept will be called multiple times
  getMaintenanceWindowSub = this.featureFlagsFacade.maintenanceWindow$
    .pipe(tap((maintenanceWindow) => (this.maintenanceWindow = maintenanceWindow)))
    .subscribe();

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return of(null).pipe(
      mergeMap(() => {
        const csApiRequest = this.configService.config.isApiCall(request.url);
        if (!csApiRequest || !this.maintenanceWindow.isActive) {
          return next.handle(request);
        }
        // block all requests except GET or custom header allow_during_maintenance during maintenance window
        if (request.method === HttpMethod.GET || Boolean(request.headers.get('allow_during_maintenance')) === true) {
          return next.handle(request);
        }
        this.uiStateFacade.displayMessage({
          message: `Our system is currently undergoing maintenance. Please try after ${this.maintenanceWindow.to.toLocaleString(
            DateTime.DATETIME_MED,
          )}`,
          type: 'Warning',
        });
        return EMPTY;
      }),
    );
  }
}
